import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scanInput", "jobDisplay", "noJobMessage"]

  connect() {
    this.scanInputTarget.focus()
  }

  scan(event) {
    event.preventDefault()
    const scanInput = this.scanInputTarget.value.trim()
    if (!scanInput) return

    this.scanInputTarget.value = ''

    fetch('/cure_station/scan', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ scan_input: scanInput })
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        alert(data.error)
      } else {
        this.displayItem(data)
      }
      this.scanInputTarget.focus()
    })
  }

  markCured(event) {
    const itemId = event.currentTarget.dataset.itemId
    fetch('/cure_station/mark_cured', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ item_id: itemId })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        alert(data.message)
        this.noJobMessageTarget.classList.remove('hidden')
        this.jobDisplayTarget.classList.add('hidden')
      } else {
        alert(data.error)
      }
      this.scanInputTarget.focus()
    })
  }

  displayItem(data) {
    this.noJobMessageTarget.classList.add('hidden')
    this.jobDisplayTarget.classList.remove('hidden')
    
    const item = data.focused_items[0]
    this.jobDisplayTarget.innerHTML = `
      <div class="bg-white shadow sm:rounded-lg p-6">
        <h3 class="text-2xl font-semibold mb-4">Order #${data.job.ordernumber}</h3>
        <p class="mb-4">Status: ${item.status}</p>
        <button data-item-id="${item.id}" data-action="click->cure-station#markCured"
                class="rounded-md bg-green-600 px-6 py-3 text-lg font-semibold text-white">
          Mark Cured
        </button>
      </div>
    `
  }
}
